
import { FirearmMetadataBase } from './firearm.metadata.base';


export class FirearmMetadata extends FirearmMetadataBase {
  constructor() {
    super();
  }
}

export const FIREARM_METADATA: FirearmMetadata = new FirearmMetadata();


